export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/22c4303fce4afc1c33d77c09ad1cb6c9.png";